<template>
    <div class="roleplayers">
        <Navbar />
        <v-container>
            <v-layout row wrap>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-btn slot="activator" color="primary" dark class="mb-2">New Roleplayer</v-btn>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-form v-model="validForm" lazy-validation>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <v-text-field v-model="editedRoleplayer.prename" label="Prename" required
                                                :rules="nameRules"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field v-model="editedRoleplayer.name" label="Name" required :rules="nameRules"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field v-model.number="editedRoleplayer.age" label="Age" type="number"
                                                required :rules="ageRules"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-select :items="genders" v-model="editedRoleplayer.gender" label="Gender"
                                                required :rules="selectRules"></v-select>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field v-model="editedRoleplayer.nationality" label="Nationality"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field v-model="editedRoleplayer.passport" label="Passport/ID No."></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-checkbox v-model="editedRoleplayer.all_shifts" label="Allways available"></v-checkbox>
                                        </v-flex>
                                        <v-flex xs12>
                                            <p class="title">Shifts
                                                <v-btn color="primary" fab small dark @click="addShift">
                                                    <v-icon dark>add</v-icon>
                                                </v-btn>
                                            </p>
                                            <div v-for="(shift, index) in editedRoleplayer.shifts" :key="index" class="mt-4">
                                                <v-card>
                                                    <v-btn color="red" fab small dark absolute top right @click="removeShift(index)">
                                                        <v-icon dark>remove</v-icon>
                                                    </v-btn>
                                                    <v-container>
                                                        <v-card-content>
                                                            <v-layout wrap>
                                                                <v-flex xs12>
                                                                    <p class="subheading">Start</p>
                                                                </v-flex>
                                                                <v-flex xs12 md6>
                                                                    <v-menu :close-on-content-click="false" v-model="shift.menu_start"
                                                                        :nudge-right="40" lazy transition="scale-transition"
                                                                        offset-y full-width min-width="290px">
                                                                        <v-text-field slot="activator" v-model="shift.start_time"
                                                                            label="Date" prepend-icon="event" readonly></v-text-field>
                                                                        <v-date-picker v-model="shift.start_time" :min="exercise.start_date.slice(0,10)"
                                                                            :max="maxDate(shift)" no-title scrollable
                                                                            @input="shift.menu_start = false"
                                                                            :show-current="false" :picker-date="exercise.start_date.slice(0,10)" />
                                                                    </v-menu>
                                                                </v-flex>
                                                                <v-flex xs12 md6>
                                                                    <v-select :items="hours" v-model="shift.start_hour"
                                                                        label="Hour"></v-select>
                                                                </v-flex>
                                                                <v-flex xs12>
                                                                    <p class="subheading">End</p>
                                                                </v-flex>
                                                                <v-flex xs12 md6>
                                                                    <v-menu :close-on-content-click="false" v-model="shift.menu_end"
                                                                        :nudge-right="40" lazy transition="scale-transition"
                                                                        offset-y full-width min-width="290px">
                                                                        <v-text-field slot="activator" v-model="shift.end_time"
                                                                            label="Date" prepend-icon="event" readonly></v-text-field>
                                                                        <v-date-picker v-model="shift.end_time" :min="minDate(shift)"
                                                                            :max="exercise.end_date.slice(0,10)"
                                                                            no-title scrollable @input="shift.menu_end = false"
                                                                            :show-current="false" :picker-date="exercise.start_date.slice(0,10)" />
                                                                    </v-menu>
                                                                </v-flex>
                                                                <v-flex xs12 md6>
                                                                    <v-select :items="hours" v-model="shift.end_hour"
                                                                        label="Hour"></v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-content>
                                                    </v-container>
                                                </v-card>
                                                <v-divider></v-divider>
                                            </div>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-textarea v-model="editedRoleplayer.others" label="Other Information"
                                                rows="1" auto-grow></v-textarea>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
                                <v-btn :disabled="!validForm" color="blue darken-1" flat @click.native="save">Save</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>

                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-layout>
            <v-data-table :items="roleplayers" :headers="headers" class="elevation-1" :search="search" :custom-filter="filterItems"
                :rows-per-page-items='[10,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'>
                <template slot="items" slot-scope="props">
                    <td @click="openRoleplayer(props.item)">{{ props.item.name }}</td>
                    <td @click="openRoleplayer(props.item)">{{ props.item.prename }}</td>
                    <td @click="openRoleplayer(props.item)">{{ props.item.age }}</td>
                    <td @click="openRoleplayer(props.item)">{{ props.item.gender }}</td>
                    <td @click="openRoleplayer(props.item)">{{ props.item.nationality }}</td>
                    <td class="justify-center layout px-0">
                        <v-icon small class="mr-2" @click="editRoleplayer(props.item)">
                            edit
                        </v-icon>
                        <v-icon small @click="deleteRoleplayer(props.item)">
                            delete
                        </v-icon>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-container>

        <v-snackbar v-model="newRoleplayerCantCreate" :right="true">
            Roleplayer can't be created.
            <v-btn color="pink" flat @click="newRoleplayerCantCreate = false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Navbar from '@/components/Navbar.vue'
    import axios from 'axios';
    axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

    export default {
        name: 'roleplayers',
        data() {
            return {
                search: '',
                roleplayers: [],
                dialog: false,
                newRoleplayerCantCreate: false,
                editedIndex: -1,
                genders: ["m", 'f'],
                hours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
                    '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
                    '20', '21', '22', '23'
                ],
                headers: [{
                        text: 'Name',
                        align: 'left',
                        value: 'name'
                    },
                    {
                        text: 'Prename',
                        value: 'prename'
                    },
                    {
                        text: 'Age',
                        value: 'age'
                    },
                    {
                        text: 'Gender',
                        value: 'gender'
                    },
                    {
                        text: 'Nationality',
                        value: 'nationality'
                    }
                ],
                eID: this.$route.params.e_id,
                exercise: {},
                editedRoleplayer: {
                    id: '',
                    prename: '',
                    name: '',
                    gender: '',
                    nationality: '',
                    age: null,
                    passport: '',
                    is_active: false,
                    injects_count: 0,
                    exercise_id: this.$route.params.e_id,
                    others: '',
                    all_shifts: false,
                    shifts: [],
                    modules: []
                },
                defaultRoleplayer: {
                    id: '',
                    prename: '',
                    name: '',
                    gender: '',
                    nationality: '',
                    age: null,
                    passport: '',
                    is_active: false,
                    injects_count: 0,
                    exercise_id: this.$route.params.e_id,
                    others: '',
                    all_shifts: false,
                    shifts: [],
                    modules: []
                },
                defaultShift: {
                    start_time: '',
                    end_time: '',
                    start_hour: '00',
                    end_hour: '00',
                    menu_start: false,
                    menu_end: false
                },
                validForm: false,
                nameRules: [
                    v => !!v || 'Value is required',
                    v => (v && v.length <= 50) || 'Value must be less than 50 characters'
                ],
                selectRules: [
                    v => !!v || 'Please select a value'
                ],
                ageRules: [
                    v => !!v || 'Age must be present',
                    v => (v && v > 0) || 'Age must be greater then 0',
                    v => (v && v < 125) || 'Age must be smaller then 125'
                ]
            }
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Roleplayer' : 'Edit Roleplayer'
            }
        },
        components: {
            Navbar
        },
        methods: {
            filterItems(items, search, filter) {
                if (!search) {
                    return items
                }
                //Split search in array
                let needleAry = search.toString().toLowerCase().split(" ").filter(x => x.trim().length > 0);

                function myFilter(item, search) {
                    return filterName(item, search) || filterPrename(item, search) ||
                        filterNationality(item, search) || filterAge(item, search) ||
                        filterGender(item, search) || filterOther(item, search)
                }

                function filterName(item, search) {
                    return item.name != null &&
                        item.name.toLowerCase().includes(search)
                }

                function filterPrename(item, search) {
                    return item.prename != null &&
                        item.prename.toLowerCase().includes(search)
                }

                function filterOther(item, search) {
                    return item.others != null &&
                        item.others.toLowerCase().includes(search)
                }

                function filterGender(item, search) {
                    if ('male'.includes(search)) {
                        return item.gender == 'm'
                    } else if ('female'.includes(search)) {
                        return item.gender == 'f'
                    }
                    return false
                }

                function filterNationality(item, search) {
                    return item.nationality != null &&
                        item.nationality.toLowerCase().includes(search)
                }

                function filterAge(item, search) {
                    return item.age != null &&
                        item.age == parseInt(search)
                }

                return items.filter(row => needleAry.every(needle => myFilter(row, needle)))
            },
            fetchRoleplayers() {
                axios.get('/exercises/' + this.eID + '/roleplayers').then(response => {
                    this.roleplayers = response.data.reverse()
                }).catch(error => {})
                axios.get('/exercises/' + this.eID).then(response => {
                    this.exercise = response.data;
                }).catch(error => {})
            },
            editRoleplayer(roleplayer) {
                this.editedIndex = this.roleplayers.indexOf(roleplayer)
                this.editedRoleplayer = Object.assign({}, roleplayer)
                this.parseShifts()
                this.dialog = true
            },
            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedRoleplayer = Object.assign({}, this.defaultRoleplayer)
                    this.editedIndex = -1
                    this.validForm = false
                }, 300)
            },
            save() {
                this.manageShiftsOnSave();
                if (this.editedRoleplayer.id === '') {
                    this.createRoleplayer(this.editedRoleplayer);
                } else {
                    this.updateRoleplayer(this.editedRoleplayer);
                }
                this.close()
            },
            createRoleplayer(roleplayer) {
                axios.post('/exercises/' + this.eID + '/roleplayers', roleplayer).then(response => {
                    this.roleplayers.unshift(response.data)
                }).catch(error => {
                    this.newRoleplayerCantCreate = true
                });
            },
            updateRoleplayer(roleplayer) {
                axios.put('/exercises/' + this.eID + '/roleplayers', roleplayer).then(response => {
                    if (this.editedIndex != -1) {
                        Object.assign(this.roleplayers[this.editedIndex], this.editedRoleplayer)
                    }
                }).catch(error => {});
            },
            deleteRoleplayer(roleplayer) {
                if (confirm('Are you sure you want to delete this roleplayer?')) {
                    axios.delete('/exercises/' + this.eID + '/roleplayers', {
                        data: Object.assign({}, roleplayer)
                    }).then(response => {
                        this.roleplayers.splice(this.roleplayers.indexOf(roleplayer), 1);
                    }).catch(error => {})
                }

            },
            openRoleplayer(roleplayer) {
                this.$router.push({
                    name: 'roleplayer',
                    params: {
                        id: roleplayer.id,
                        e_id: this.eID
                    }
                })
            },
            addShift() {
                this.editedRoleplayer.shifts = this.editedRoleplayer.shifts || []
                this.editedRoleplayer.shifts.push(Object.assign({}, this.defaultShift))
            },
            manageShiftsOnSave() {
                var lengthShifts = this.editedRoleplayer.shifts.length
                for (var i = 0; i < lengthShifts; i++) {
                    var shift = this.editedRoleplayer.shifts[i];
                    shift.start_time = shift.start_time + 'T' + shift.start_hour + ':00:00.000Z';
                    shift.end_time = shift.end_time + 'T' + shift.end_hour + ':00:00.000Z';
                    delete shift.start_hour;
                    delete shift.end_hour;
                    delete shift.menu_start;
                    delete shift.menu_end
                    this.editedRoleplayer.shifts[i] = shift;
                }
            },
            minDate(shift) {
                if (shift.start_time) {
                    return shift.start_time
                };
                return this.exercise.start_date.slice(0, 10)
            },
            maxDate(shift) {
                if (shift.end_time) {
                    return shift.end_time
                };
                return this.exercise.end_date.slice(0, 10)
            },
            parseShifts() {
                var lengthShifts = this.editedRoleplayer.shifts.length
                for (var i = 0; i < lengthShifts; i++) {
                    var shift = this.editedRoleplayer.shifts[i]
                    shift.start_hour = shift.start_time.slice(11, 13)
                    shift.start_time = shift.start_time.slice(0, 10)
                    shift.end_hour = shift.end_time.slice(11, 13)
                    shift.end_time = shift.end_time.slice(0, 10)
                    shift.menu_start = false
                    shift.menu_end = false
                    this.editedRoleplayer.shifts[i] = shift
                }
            },
            removeShift(index) {
                if (confirm('Do you want to remove the shift?')) {
                    this.editedRoleplayer.shifts.splice(index, 1)
                }
            }
        },
        mounted() {
            this.fetchRoleplayers();
        }
    }
</script>